import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './tab.module.scss';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';

export default function Tab(props) {
    const { ancestorProps, id, title, estil } = props;
    const { activeTabWebview, setActiveTabWebview } = ancestorProps;
    const [tabActive, setTabActive] = useState(null);
    const router = useRouter();

    useEffect(() => {
        if (router.query['seccio'] !== id && activeTabWebview === id) {
            router.query['seccio'] = id;
            router.push({ ...router }, undefined, { shallow: true, scroll: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabActive]);

    const stylesTab = clsx({
        [styles[estil]]: !__isEmpty(estil),
        [styles.tabNav]: true
    });

    return (
        <li
            className={stylesTab}
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    setActiveTabWebview(id);
                    setTabActive(id);
                }
            }}
            onClick={() => {
                setActiveTabWebview(id);
                setTabActive(id);
            }}
            data-testid={`tab-${id}`}
        >
            <span className={activeTabWebview === id ? styles.active : ''}>{title}</span>
        </li>
    );
}
